module.exports = __webpack_public_path__ + "img/courseCheck.9b4a5687.png";